/** @format */

import React, { useState, useEffect } from 'react'
import * as Styles from './style'
import { Formik } from 'formik'
import * as Yup from 'yup'
import axios from 'axios'
import Cookies from 'universal-cookie'
import close from '../../../assets/images/close.png'
import { toast } from 'react-toastify'
import { SelectGroup } from '../../../shared/SelectGroup/SelectGroup'
import { InputGroup } from '../../../shared/InputGroup/InputGroup'
import { Button, message } from 'antd'
const readCookie = require('../../../../cookie.js').readCookie

const cookies = new Cookies()

// ✅ Validation Schema
const clfSchema = Yup.object().shape({
  name: Yup.string().required('CLF Name is required'),  
  state: Yup.string().required('State is required'),
  district: Yup.string().required('District is required'),
  block: Yup.string().required('Block is required'),
})

// ✅ Component
const CreateCLFForm = ({ showClfModal, setShowClfModal, onSuccess }) => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [states, setStates] = useState([])
  const [districts, setDistricts] = useState([])
  const [blocks, setBlocks] = useState([])
  const [selectedState, setSelectedState] = useState('')
  const [selectedDistrict, setSelectedDistrict] = useState('')

  const token = cookies.get('access_token')

  const handleClose = () => setShowClfModal(false)

  // ✅ Fetch states
  const fetchStates = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/v1/location/states`,
        { headers: { 'x-auth-token': JSON.parse(readCookie('access_token')) } }
      )
      setStates(res.data.data.states || [])
    } catch (err) {
      message.error('Failed to load states')
    }
  }

  // ✅ Fetch districts
  const fetchDistricts = async stateName => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/v1/location/districts?states=${stateName}`,
        { headers: { 'x-auth-token': JSON.parse(readCookie('access_token')) } }
      )
      setDistricts(res.data.districts || [])
    } catch (err) {
      message.error('Failed to load districts')
    }
  }

  // ✅ Fetch blocks
  const fetchBlocks = async districtName => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/v1/location/blocks?district=${districtName}`,
        { headers: { 'x-auth-token': JSON.parse(readCookie('access_token')) } }

      )
      setBlocks(res.data.blocks || [])
      if (!res.data.blocks.length) {
        message.info('No blocks found for the selected district')
      }
    } catch (err) {
      toast.error('Failed to load blocks')
      message.error('Failed to load blocks')
    }
  }

  useEffect(() => {
    if (showClfModal) fetchStates()
  }, [showClfModal])

  useEffect(() => {
    if (selectedState) fetchDistricts(selectedState)
  }, [selectedState])

  useEffect(() => {
    if (selectedDistrict) fetchBlocks(selectedDistrict)
  }, [selectedDistrict])

  const handleSubmit = async values => {
    setIsSubmitting(true)
    console.log('Form Values:', values)
    try {
      const payload = {
        name: values.name.trim(),
        blockId: values.block,
      }
      console.log('Payload:', payload)

      await axios.post(
        `${process.env.REACT_APP_API_URL}/api/v1/humblebee/clf/create`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            source: 'humblebee_admin',
          },
        }
      )

      toast.success('CLF created successfully')
      onSuccess()
      handleClose()
    } catch (err) {
        toast.error('Failed to create: ' + err?.response?.data?.message || '')
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <Styles.ModalWrapper style={{ display: showClfModal ? 'flex' : 'none' }}>
      <Styles.ModalContent>
        <Formik
          initialValues={{
            name: '',
            state: '',
            district: '',
            block: '',
          }}
          validationSchema={clfSchema}
          onSubmit={handleSubmit}
        >
          {formik => (
            <Styles.FormWithCloseButton onSubmit={formik.handleSubmit}>
              <Styles.CloseButtonDiv>
                <h3>Create New CLF</h3>
                <Styles.FormCloseButton onClick={handleClose}>
                  <img src={close} alt="Close" />
                </Styles.FormCloseButton>
              </Styles.CloseButtonDiv>

              <Styles.MainSupplierFormDiv>
                <InputGroup
                  PlaceholderText="Enter CLF Name"
                  LabelText="CLF Name"
                  name="name"
                  type="text"
                  star="*"
                  value={formik.values.name}
                  onChange={formik.handleChange}
                />

               
                <SelectGroup
                  PlaceholderText="Select State"
                  LabelText="State"
                  name="state"
                  onChange={e => {
                    setSelectedState(e.target.value)
                    formik.handleChange(e)
                  }}
                  value={formik.values.state}
                  options={states.map(s => s.name)}
                  star="*"
                />

                <SelectGroup
                  PlaceholderText="Select District"
                  LabelText="District"
                  name="district"
                  onChange={e => {
                    setSelectedDistrict(e.target.value)
                    formik.handleChange(e)
                  }}
                  value={formik.values.district}
                  options={districts.map(d => d.name)}
                  star="*"
                  disabled={!selectedState}
                />

<SelectGroup
  PlaceholderText="Select Block"
  LabelText="Block"
  name="block"
  onChange={e => {
    const selectedBlock = blocks.find(b => b.name === e.target.value)
    formik.setFieldValue('block', selectedBlock?._id || '')
  }}
  value={
    blocks.find(b => b._id === formik.values.block)?.name || ''
  }
  options={blocks.map(b => b.name)}
  star="*"
  disabled={!selectedDistrict}
/>

              </Styles.MainSupplierFormDiv>

              <Button
                type="primary"
                htmlType="submit"
                loading={isSubmitting}
                className="mt-4"
              >
                {isSubmitting ? 'Creating...' : 'Create CLF'}
              </Button>
            </Styles.FormWithCloseButton>
          )}
        </Formik>
      </Styles.ModalContent>
    </Styles.ModalWrapper>
  )
}

export default CreateCLFForm;
